import Main from '@/pages/framework/main.vue'

let routes = [{
	path: '/',
	component: Main,
	children: [{
		path: 'gdtex/mgr/tp',
		meta: {
			auth: true,
			code: 'GDTEX_MGR_TP_LIST'
		},
		component: resolve => require(['@/pages/boxmai/gdtex/mgr/tp/index.vue'], resolve),
		name: 'TP处理列表'
	},{
		path: 'gdtex/mgr/tp/detail',
		meta: {
			auth: true,
			code: 'GDTEX_MGR_TP_DETAIL'
		},
		component: resolve => require(['@/pages/boxmai/gdtex/mgr/tp/detail.vue'], resolve),
		name: 'TP处记录详情'
	},{
		path: 'gdtex/mgr/tp/import/list',
		meta: {
			auth: true,
			code: 'GDTEX_MGR_TP_IMPORT_LIST'
		},
		component: resolve => require(['@/pages/boxmai/gdtex/mgr/tp/tp-imports.vue'], resolve),
		name: 'TP文件导入记录'
	},{
		path: 'gdtex/mgr/tp/art/import/list',
		meta: {
			auth: true,
			code: 'GDTEX_MGR_TP_ART_IMPORT_LIST'
		},
		component: resolve => require(['@/pages/boxmai/gdtex/mgr/tp/art-imports.vue'], resolve),
		name: 'ArtCard文件导入记录'
	},{
		path: 'gdtex/mgr/mdr',
		meta: {
			auth: true,
			code: 'GDTEX_MGR_MDR_LIST'
		},
		component: resolve => require(['@/pages/boxmai/gdtex/mgr/mdr/index.vue'], resolve),
		name: 'MDR资料库'
	},{
		path: '/gdtex/mgr/mdr/detail',
		meta: {
			auth: true,
			code: 'GDTEX_MGR_MDR_DETAIL'
		},
		component: resolve => require(['@/pages/boxmai/gdtex/mgr/mdr/detail.vue'], resolve),
		name: 'MDR资料详情'
	},{
		path: 'gdtex/mgr/mca',
		meta: {
			auth: true,
			code: 'GDTEX_MGR_MCA_LIST'
		},
		component: resolve => require(['@/pages/boxmai/gdtex/mgr/mca/index.vue'], resolve),
		name: 'MCA资料库'
	},{
		path: '/gdtex/mgr/mca/detail',
		meta: {
			auth: true,
			code: 'GDTEX_MGR_MCA_DETAIL'
		},
		component: resolve => require(['@/pages/boxmai/gdtex/mgr/mca/detail.vue'], resolve),
		name: 'MCA资料详情'
	},{
		path: 'gdtex/art',
		meta: {
			auth: true,
			code: 'GDTEX_MGR_ART_LIST'
		},
		component: resolve => require(['@/pages/boxmai/gdtex/mgr/tp/art-imports.vue'], resolve),
		name: '手刮样资料库'
	},{
		path: 'gdtex/mgr/color',
		meta: {
			auth: true,
			code: 'GDTEX_MGR_COLOR_LIST'
		},
		component: resolve => require(['@/pages/boxmai/gdtex/mgr/color/index.vue'], resolve),
		name: '色卡'
	},{
		path: 'gdtex/follow/samples',
		meta: {
			auth: true,
			code: 'GDTEX_FOLLOW_SAMPLES_LIST'
		},
		component: resolve => require(['@/pages/boxmai/gdtex/follow/samples/index.vue'], resolve),
		name: '样办跟进'
	},{
		path: 'gdtex/report/mdr',
		meta: {
			auth: true,
			code: 'GDTEX_REPORT_MDR_LIST'
		},
		component: resolve => require(['@/pages/boxmai/gdtex/report/mdr/index.vue'], resolve),
		name: 'MDR开发报表'
	},{
		path: 'gdtex/report/order',
		meta: {
			auth: true,
			code: 'GDTEX_REPORT_ORDER_LIST'
		},
		component: resolve => require(['@/pages/boxmai/gdtex/report/order/index.vue'], resolve),
		name: '订单跟进报表'
	},{
		path: 'gdtex/report/process',
		meta: {
			auth: true,
			code: 'GDTEX_REPORT_PROCESS_LIST'
		},
		component: resolve => require(['@/pages/boxmai/gdtex/report/process/index.vue'], resolve),
		name: '做工尺寸报表'
	},{
		path: 'gdtex/qc/report/process',
		meta: {
			auth: true,
			code: 'GDTEX_QC_REPORT_PROCESS_LIST'
		},
		component: resolve => require(['@/pages/boxmai/gdtex/report/qc/index.vue'], resolve),
		name: '查货尺寸报表'
	},{
		path: 'gdtex/datadict/translate',
		meta: {
			auth: true,
			code: 'GDTEX_DATADICT_TRANSLATE_LIST'
		},
		component: resolve => require(['@/pages/boxmai/gdtex/mgr/tp/datadict-translate.vue'], resolve),
		name: '字典翻译'
	}]
}];

export default routes;


// WEBPACK FOOTER //
// ./src/config/routes/tp.js